export const parseGenusSpecies = (input: string) => {
  // capitalize first word and lowercase the rest
  if (!input) return input;
  const words = input.split(" ");
  if (words[0].toLowerCase() === "empty") return "Empty";
  if (words.length === 1) {
    return (
      words[0].charAt(0).toUpperCase() +
      words[0].slice(1).toLowerCase() +
      " spp."
    );
  }
  return (
    words[0].charAt(0).toUpperCase() +
    words[0].slice(1).toLowerCase() +
    " " +
    words
      .slice(1)
      .map((word) => word.toLowerCase())
      .join(" ")
  );
};
